class Dropdown {
  init () {
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.dropdown').length) {
        $('.dropdown-content-header').slideUp()
        $('.arrow-icon').removeClass('rotate-180')
      }
    })

    $('.dropdown-btn').click(function (e) {
      e.preventDefault()
      $('.arrow-icon').toggleClass('rotate-180')
      $('.dropdown-content-header').not($(this).closest('.dropdown').find('.dropdown-content-header')).slideUp()
      $(this).closest('.dropdown').find('.dropdown-content-header').slideToggle()
    })

    $('.dropdown-content').click(function (e) {
      e.stopPropagation()
    })
  }
}

export default Dropdown
